import React from 'react';
import { createAnalogousList } from './createAnalogousLists';
import feedbackTexts from './feedback_texts.json';
import bubbles from "../../mascot/bubble_right.svg";
import { SwapButton } from '../../buttons/swapButton';
import { NoSwapButton } from '../../buttons/noSwapButton';
import { SortNumberButton } from '../../buttons/sortNumberButton';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export default class ErrorFeedback extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            feedbackList : createAnalogousList(this.props.list),
            selectedButtonColour : 'blueviolet',
            standardButtonColour : '#b578ee',
            alreadySortedButtonColour: '#07b123',
            correctActionColour: '#07b123',
            wrongActionColour: '#b1b0af'
        }
        this.generatePreviousStep = this.generatePreviousStep.bind(this);
    }

    /*
    * Creates an analogous list to the previous sorting step on the basis of the analogous list to the current step
    * and the actual previous sorting step by swapping or not swapping the elements that are analysed in the previous step 
    * based on the correct action.
    */
    generatePreviousStep(){
        let previous =JSON.parse(JSON.stringify( this.state.feedbackList));
        let previousIndices = [this.props.trueIndices[0]-1,this.props.trueIndices[0]];
        if(this.props.previousList[previousIndices[0]] > this.props.previousList[previousIndices[1]]){ 
            let temp = previous[previousIndices[0]];
            previous[previousIndices[0]] = previous[previousIndices[1]];
            previous[previousIndices[1]] = temp;
        }  
        return previous;
    }

    /*
    * Renders and returns the errorFeedback component.
    * The content of the feedback is dependend on the values of the properties with which it is called, specifically the type of error.
    * Feedback for the six error types and unspecified error category consists of:
    * Error Type 1: feedbacktext(0) + mascot + analogous example with marked selected buttons + greyed out SwapButton and highlighted NoSwapButton
    * Error Type 2: feedbacktext(1) + mascot + analogous example with marked selected buttons + highlighted SwapButton and greyed out NoSwapButton
    * Error Type 3: feedbacktext(2) + mascot + analogous example with marked selected buttons
    * Error Type 4: feedbacktext(3) + mascot + analogous example with marked selected buttons
    * Error Type 5: feedbacktext(4) + mascot + analogous example with marked selected buttons for the previous and current steps
    * Error Type 6: feedbacktext(5) + mascot + analogous example with marked selected buttons and highlighted buttons at the end of the list that 
    *               show which buttons are already sorted and should not be interacted with anymore
    * Unspecified:  feedbacktext(6) + mascot + analogous example with marked selected buttons
    */

    render(){
        const prevList = this.generatePreviousStep();
        return(
            <div>
                <div className='App-Buttons'>
                <img src={bubbles}  className="Feedback-Mascot" alt={"Bubbles, das Maskottchen des Bubblesort-Tutors, eine blaue und lilane Seifenblase."}/> 
                 <p> 
                        {feedbackTexts[this.props.errorType]} <br/> <br/> <br/><br/>
                    </p> 
                </div>   
                
                {this.props.errorType === 4 &&
                    <div>
                        <h5> Wenn ich mir im letzten Schritt diese beiden Zahlen angeschaut hast...: </h5>
                        <div className="App-buttons" style={{itemAlign : 'center'}}>
                            {prevList.map((nr,index) =>            
                                <SortNumberButton key={index} id={index} value= {nr}
                                    style= {{backgroundColor : (this.props.trueIndices[0]-1 === index || this.props.trueIndices[0] === index ? this.state.selectedButtonColour 
                                            : this.state.standardButtonColour)}} className='Round-button'>
                                    {nr}
                                </SortNumberButton>       )}
                        </div>
                        <h5>... dann schaue ich mir in diesem Schritt diese beiden Zahlen an:</h5>
                    </div>
                }  
                <div className="App-buttons">
                {this.state.feedbackList.map((nr,index) =>            
                    <SortNumberButton key={index} id={index} value= {nr}
                        style= {{cursor : 'auto', backgroundColor : (this.props.trueIndices.indexOf(index) !== -1 ? this.state.selectedButtonColour 
                                : (this.props.errorType === 5 && index > this.props.list.length - this.props.loop ? this.state.alreadySortedButtonColour : this.state.standardButtonColour))}} className='Round-button'>
                        {nr}
                    </SortNumberButton>       )} 
                </div>

                {this.props.errorType === 0 &&
                    <div className='App-buttons'>
                        <SwapButton style= {{cursor : 'auto', backgroundColor : this.state.wrongActionColour}}/>
                        <NoSwapButton style= {{cursor : 'auto', backgroundColor : this.state.correctActionColour}}/> 
                    </div>
                }   

                {this.props.errorType === 1 &&
                    <div className='App-buttons'>
                        <SwapButton style= {{cursor : 'auto', backgroundColor : this.state.correctActionColour}}/>
                        <NoSwapButton style= {{cursor : 'auto', backgroundColor : this.state.wrongActionColour}}/> 
                    </div>
                }                
            </div>
        )};
}